import { createStorefrontApiClient } from '@shopify/storefront-api-client';

const Storefront = createStorefrontApiClient({
  storeDomain: `https://${Shopify.shop}`,
  apiVersion: '2024-04',
  publicAccessToken: theme.integrations.storefront.accessToken,
});

export default Storefront;
